import React from 'react';
import { 
    Image, 
    TouchableOpacity, 
    View, 
    Text, 
    StyleSheet, 
    // Modal, 
    Linking, 
    Alert, 
    ActivityIndicator 
} from "react-native";

import Modal from './base/Modal';

// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import Config from '../../constants/Config';
import Colors from '../../constants/Colors'
import FontStyles from '../../constants/FontStyle';

const LocationModal = (props) => {

    const clickAreaRef = React.useRef()

    const requestCall = () => {
        if (props.seller.seller_details) {
            Linking.openURL('tel:' + props.seller.seller_details.phone)
        }
    }

    const handleClickOutside = e => {
        e.persist()
        if (clickAreaRef.current) {
            if (e.target === clickAreaRef.current._nativeTag) {
                hideModal()
            }
        }
    }

    return (
        <Modal
            presentationStyle='overFullScreen'
            animationType="slide"
            transparent={true}
            visible={props.isActive}
            onRequestClose={() => {
                props.hideModal()
            }}>
            <View
                ref={clickAreaRef}
                onStartShouldSetResponder={handleClickOutside}
                style={[styles.overlay, { justifyContent: props.loadingContent ? 'center' : 'flex-end' }]}
            >
                {!props.loadingContent
                    ? <View style={styles.container}>

                        <TouchableOpacity
                            style={styles.closeButton}
                            onPress={() => {
                                props.hideModal()
                            }} >
                            <Text style={styles.closeButtonText}>Close</Text>
                            <Icon name='md-close' size={24} color='#FFFFFF' />
                        </TouchableOpacity>

                        {props.seller ?
                            <View style={[styles.card, { alignItems: 'center' }]}>

                                <Image
                                    source={{ uri: `${Config.uploadUrl}${props.seller.manufacturer_details.upload.path}` }}
                                    style={{
                                        width: 78,
                                        height: 78,
                                        marginTop: 40
                                    }} />
                                <Text style={[styles.cardBody, {
                                    marginTop: 11,
                                    letterSpacing: 0,
                                    ...FontStyles.dark,
                                    ...FontStyles.size20,
                                    ...FontStyles.lh24,
                                    ...FontStyles.bold,
                                    textAlign: 'center',
                                }]}>{props.seller.seller_details.name}</Text>

                                <Text style={[styles.cardBody, {
                                    marginTop: 4,
                                    color: Colors.shades._7,
                                    ...FontStyles.size15,
                                    ...FontStyles.lh18,
                                    ...FontStyles.normal,
                                    textAlign: 'center',
                                }]}>{props.seller.manufacturer_details.name} &middot; {props.seller.manufacturer_details.address.split(' ').splice(-1, 1)}</Text>

                                <TouchableOpacity
                                    style={[styles.actionButton, { flexDirection: 'row', justifyContent: 'center', marginTop: 37, marginBottom: 43, width: 188 }]}
                                    onPress={requestCall} >
                                    <Icon name="ios-call" size={18} color="#FFFFFF" style={{ alignSelf: 'center', marginRight: 8 }} />
                                    <Text style={[styles.actionButtonText, { alignSelf: "center" }]}>Call Sales Rep</Text>
                                </TouchableOpacity>

                            </View>
                            : null
                        }
                    </View>
                    : <ActivityIndicator size={28} color="white" style={{ alignSelf: 'center' }} />
                }
            </View>
        </Modal>
    )
}

export default LocationModal

const styles = StyleSheet.create({
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.6)',
        height: '100%',
        alignItems: 'center'
    },
    container: {
        width: '100%',
        // paddingHorizontal: 16,
        justifyContent: 'center'
    },
    closeButton: {
        flexDirection: 'row',
        alignSelf: 'flex-end',
        marginBottom: 8,
        marginRight: 16,
    },
    closeButtonText: {
        color: Colors.whiteColor,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        alignSelf: 'center',
        marginRight: 8,
    },
    card: {
        borderTopLeftRadius: 25,
        borderTopRightRadius: 25,
        backgroundColor: '#FFFFFF',
        paddingHorizontal: 20,
        paddingTop: 24,
        paddingBottom: 16
    },
    cardBody: {
        width: 288,
        ...FontStyles.dark,
        ...FontStyles.size14,
        ...FontStyles.lh20,
        ...FontStyles.medium,
    },
    actionButton: {
        height: 36,
        width: '100%',
        borderRadius: 4,
        backgroundColor: '#3B54EC',
        marginBottom: 7,
    },
    actionButtonText: {
        marginVertical: 10,
        color: Colors.whiteColor,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        alignSelf: 'center',
    },
})